import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../Components/Header";
import moment from "moment";
import { Client_Search } from "../../Configuration/API_URL";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import TodateComponent from "./TodateComponent";
import FromdateComponent from "./FromdateComponent";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import CostReportTable from "../../Components/ReportTables/CostReportTable";
import DurationChangeComponent from "./DurationChangeComponent";
import ItemisedMarginTable from "../../Components/ReportTables/ItemisedMarginTable";
import SmallLoader from "../../Components/Common/smallLoader";

function ItemisedMarginReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [data, setData] = useState("");
  const [errorResp, setErrorResp] = useState("");
  const [nameError, setNameError] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [count, setCount] = useState();
  const [customShow, setCustomShow] = useState(false);
  const [selectDuration, setSelectDuration] = useState("");
  const [errorGrid, setErrorGrid] = useState(false);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [gridPage, setGridPage] = useState(1);
  const [gridLoader, setGridLoader] = useState(false);
  const [gridTotalCount, setGridTotalCount] = useState(0);
  const [fromDateError, setFromDateError] = useState("");

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        },
      );

      const res = ApiResDecrypt(getSearchDetail?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
      setMainError(false);
    }
  }

  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  const getItemisedMargionReport = async (fileView) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileView === "pdf") {
      setSmallLoaderPdf(true);
    }
    if (fileView === "grid") {
      gridPage === 1 ? setLoader(true) : setLoader(false);
    }
    let payloadValue = {
      clientCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      pageNo: fileView === "grid" ? gridPage : -1,
      PageSize: fileView === "grid" ? 10 : -1,
    };

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.Itemised_Margin_Report,
        //payloadValue,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        },
      );
      const res = ApiResDecrypt(getDetails?.data);
      //const res = getDetails?.data;
      if (res?.status === 0) {
        if (fileView === "grid") {
          const newRows = res?.data?.itemizedList || [];
          const total = res?.data?.totalCount || 0;
          setGridTotalCount(total);
          setData((prev) => (gridPage === 1 ? newRows : [...prev, ...newRows]));
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setData([]);
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setGridLoader(false);
    }
  };

  const handleFromDateChange = (e) => {
    setErrorGrid(false);
    setData([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setFromDateError(false);
    setServerError(false);
    if (toDate && checkDateRange(fromDate, toDate)) setErrorResp(false);
  };
  const handleToDateChange = (e) => {
    setErrorGrid(false);
    setData([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp(false);
    setServerError(false);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleOnClick = (e) => {
    setShow(false);
    if (clientCode) {
      if (e.target.value) {
        //if (selectDuration) {
        // if (
        //   compareDate(fromDate) &&
        //   compareDate(toDate) &&
        //   checkDateRange(fromDate, toDate)
        // ) {
        if (e.target.value === "grid") {
          setGridPage(1);
          setGridTotalCount(0);
          setData([]);
        }
        getItemisedMargionReport(e.target.value);
        setErrorResp(false);
        //} else {
        //   if (!fromDate) {
        //     setFromDateError("Please Select From Date");
        //   }
        //   if (!toDate) {
        //     setErrorResp("Please Select To Date");
        //   } else {
        //     setErrorResp("Please Select Correct Date");
        //   }
        // }
        // } else {
        //   setErrorResp("Please Select Duration");
        // }
      }
    } else {
      setMainError("Please Select Client Name/Code");
    }
  };

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const handleGridScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (
      scrollTop + clientHeight >= scrollHeight - 5 &&
      !gridLoader &&
      data.length < gridTotalCount
    ) {
      setGridLoader(true);
      setGridPage((prev) => prev + 1);
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration = () => {
    setErrorGrid(false);
    setData([]);
    setErrorResp(false);
    setServerError(false);
  };

  useEffect(() => {
    if (gridPage > 1) {
      getItemisedMargionReport("grid");
    }
  }, [gridPage]);

  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports interest-report-wrapper">
        <div className="card-box">
          <div className="mb-4">
            <h2 className="report-title">Itemised Margin Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-4 col-12">
              <div className="row d-flex justify-content-between">
                <div className="form-group w-100">
                  <label className="form-label">
                    {Constants.Client_Search}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="rm-custom-dropdown">
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Search by Name/Code"
                      autoComplete="off"
                      value={clientCode}
                      onChange={(e) => {
                        let value = e.target.value.toUpperCase();
                        value = value.replace(/[^A-Z0-9 ]/gi, "");
                        value = value.replace(/\s{2,}/g, " ");
                        value = value.replace(/^\s+/, "");
                        setClientCode(value);
                        setShow(true);
                        setErrorGrid(false);
                      }}
                    />
                    <button
                      className="rm-dropdown-btn"
                      onClick={() => setShow(!show)}
                    >
                      <span className="icon-right-arrow-triangle"></span>
                    </button>
                    {show && (
                      <>
                        <ul
                          className="rm-mapping-ap border-0"
                          onScroll={(e) => handleScroll(e)}
                        >
                          {clientList &&
                            clientList.map((item, i) => (
                              <li
                                key={i}
                                className="rm-maping-item-wrapper"
                                onClick={() => {
                                  setClientCode(item?.clientCode);
                                  setShow(false);
                                }}
                              >
                                <div> {item?.clientname}</div>
                                <div> {item?.clientCode}</div>
                              </li>
                            ))}
                          {scrollLoader && !loader && (
                            <div className="loader-center">
                              <LoaderForSearch />
                            </div>
                          )}
                          {nameError && !scrollLoader && (
                            <li
                              className="rm-maping-item-wrapper"
                              style={{
                                borderBottom: "none",
                                fontSize: "12px",
                              }}
                            >
                              {nameError}
                            </li>
                          )}
                        </ul>
                      </>
                    )}
                  </div>
                  {mainError && (
                    <span className="to-date-error" style={{ bottom: "-10px" }}>
                      {mainError}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="text-center search-btn-wrapper mb-3">
              <button
                value="grid"
                className="send-message new-search-btn"
                onClick={handleOnClick}
              >
                {Constants.Search}
              </button>
            </div>
            {/* <div className="col-md-3 col-sm-4 col-12">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                  required={true}
                />
              </div>
              {errorResp && !selectDuration && (
                <span className="duration-date-error">{errorResp}</span>
              )}
            </div> */}
            {/* {customShow ? (
              <div className="col-md-3 col-sm-4 col-12">
                <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                  clientWiseReportForCustomCalanderIcon={true}
                  errorResponse={fromDateError}
                />
              </div>
            ) : null}
            {customShow ? (
              <div className="col-md-3 col-sm-4 col-12">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
            ) : null} */}
          </div>

          <div className="table-top-nav">
            <div className="table-dt-btn">
              <button
                value="excel"
                onClick={handleOnClick}
                className="generate-button text-green new-excel-btn"
              >
                {" "}
                {smallLoaderExcel ? (
                  <div>
                    <SmallLoader />
                  </div>
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    {"Excel"}
                  </>
                )}
              </button>
              <button
                className="generate-button new-pdf-btn"
                value="pdf"
                onClick={handleOnClick}
              >
                {smallLoaderPdf ? (
                  <div>
                    <SmallLoader />
                  </div>
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span>
                    {"PDF"}
                  </>
                )}
              </button>
            </div>
          </div>

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : data && data.length > 0 ? (
              <div
                className="mt-4 itemised-table-wrapper"
                onScroll={handleGridScroll}
              >
                <ItemisedMarginTable data={data} />
                {gridLoader && (
                  <div className="d-flex w-100 justify-content-center">
                    <LoaderForSearch />
                  </div>
                )}
              </div>
            ) : serverError ? (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            ) : errorGrid ? (
              noDataFound(errorGrid)
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default ItemisedMarginReportSidebar;
